import React, { useEffect } from 'react'
import './Product_description.css'
import Breadcrumb_Comp from '../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
import Product_Image from './Product_Image/Product_Image'
import Product_Description from './Product_Description/Product_Description'
import TopReviews from './TopReviews/TopReviews'
import You_may_also from './you-may-also-like/You_may_also'
import Similar_products from './similar-products/Similar_products'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { GetSingleProduct } from '../../features/admin/products/slice'
import { AvgReviewRating } from '../../features/reviewRating/reviewRatingSlice'
import { decodeId } from '../../utils/common'


const Product_description = () => {

    const { id } = useParams()

    const dispatch = useDispatch();
    const product = useSelector((state) => state.commerce.products.product);
    const avgRating = useSelector((state) => state.reviewRating.avg_rating);




    useEffect(() => {
        dispatch(GetSingleProduct(decodeId(id)));
        dispatch(AvgReviewRating({ product_id: decodeId(id) }));
    }, [dispatch, id]);

    const breadcrumbs = [
        { label: "Explore", link: "/explore", active: false },
        {
            label: product?.name || "",
            link: "",
            active: true,
        },
    ];

    return (
        <>
            <section className='Product_description_sec'>
                <div className='container'>
                    <Breadcrumb_Comp data={breadcrumbs} />

                    <div className='product_description_container'>
                        <div className='product_information'>
                            <div className='row justify-content-center'>
                                <div className='col-lg-5 col-md-8 col-12'>
                                    <Product_Image product={product} />
                                </div>
                                <div className='col-lg-7 col-md-12'>
                                    <Product_Description product={product} avgRating={avgRating} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <Similar_products catId={product?.p_category_id} prodId={decodeId(id)} />

                    <div className='top_3_review_section'>
                        <TopReviews id={decodeId(id)} />
                    </div>

                    <div className='youmayalso_sec'>
                        <You_may_also />
                    </div>


                </div>
            </section>
        </>
    )
}

export default Product_description